<main class="ceo-page">

    <!-- HERO -->
    <section class="hero-section">

        <img
            [src]="baseApiUrl + '/uploads/images/ceo_message/ceo_picture_2.jpeg'"
            class="hero-image"
            alt="CEO">

        <div class="hero-overlay">
            <h1>CEO's Message</h1>
        </div>

    </section>


    <div class="paragraph">
        <div class="row">

            <div class="col-lg-8 col-md-8 col-sm-8 col-12 paragraph-text sm-mb-0 mb-3" *ngIf="isEnglish()">

                <section class="report-wrapper">

                    <!-- INTRO -->
                    <div class="intro-section">

                        <img
                            [src]="baseApiUrl + '/uploads/images/ceo_message/semicolumn.svg'"
                            class="quote-icon">

                        <h2>
                            Turning Challenges into Resilience and Adaptability
                        </h2>

                    </div>

                    <!-- SECTION 1 -->

                    <section class="report-section">

                        <h3>2025 – The Year We Held the Line</h3>

                        <p>
                            Border tensions, subdued credit demand, a sluggish recovery in tourism and real estate — 2025 compounded an already demanding environment. 
                            Across the banking system, Non-Performing Loans climbed to 8.9 percent from 7.4 percent in 2024, 
                            while outstanding loans grew modestly at 4.1 percent to USD 63 billion. Deposits surged 14.7 percent to USD 65.7 billion 
                            and total assets expanded 9.7 percent to USD 98.7 billion — a system with liquidity, but exercising discipline about where to deploy it. 
                            The era of expansion-driven banking gave way to something more demanding: risk-focused, resilience-oriented practice.
                        </p>

                        <div class="stats-grid">

                            <div class="stat-card">
                                <small>Outstanding loans (system)</small>
                                <h4>USD 63B</h4>
                                <span>+4.1% year-on-year</span>
                            </div>

                            <div class="stat-card">
                                <small>Customer deposits (system)</small>
                                <h4>USD 65.7B</h4>
                                <span>+14.7% year-on-year</span>
                            </div>

                            <div class="stat-card">
                                <small>NPL Ratio</small>
                                <h4>8.9%</h4>
                                <span>Up from 7.4% in 2024</span>
                            </div>

                        </div>

                        <p>
                            We had already transitioned to creditworthiness-based loan pricing and delegated lending authority to frontline teams, 
                            supported by rigorous post-disbursement review, while reshaping our internal functions from gatekeepers into operational enablers.
                        </p>

                        <p>
                            The defining move of 2025 was the launch of the Migrant Worker Loan, our clearest statement of intent. 
                            We chose to serve Cambodia’s overseas workers with verified employment contracts, a growing yet underserved market. 
                            Early traction has confirmed both the market’s potential and our commitment to it.
                        </p>

                    </section>

                    <!-- PEOPLE SECTION -->

                    <section class="report-section">

                        <h3>People – The Only Advantage that Compounds</h3>

                        <p>
                            Every reform, every system, every product we have built is only as powerful as the people operating it. 
                            When an organization concentrates exceptional, motivated people — and genuinely trusts their judgment — it moves fast, 
                            decides well, and needs little bureaucracy to hold itself together. 
                        </p>

                        <div class="quote-box">

                            <p>
                                The quality of an institution’s decisions can never exceed the quality of the people it chooses and trusts. 
                                Therefore, continuously strengthening the quality of human resources is the most effective way to solve long-term challenges.
                            </p>

                        </div>

                    </section>

                    <!-- 2026 -->

                    <section class="report-section">

                        <h3>2026 – The Year We Advance</h3>

                        <p>
                            Survival was the proof of concept. In 2026, NHFC presses forward — not because the environment has improved, 
                            but because readiness does not wait for ease. Four interlocking moves form our advance.
                        </p>

                        <div class="strategy-grid">

                            <div class="strategy-card">

                                <h4>
                                    1. Kampong Chhnang Branch
                                </h4>

                                <p>
                                    Extending our physical reach into a province with underserved demand. Proximity to clients is not convenience — it is commitment.
                                </p>

                            </div>

                            <div class="strategy-card">

                                <h4>
                                    2. LOS Structural Modernization 
                                </h4>

                                <p>
                                    We will continue modernizing and rebuilding our system architecture to ensure that our core infrastructure can evolve at the speed of our ambition 
                                    and support the institution’s long-term growth.
                                </p>

                            </div>

                            <div class="strategy-card">

                                <h4>
                                    3. Mobile App Development 
                                </h4>

                                <p>
                                    Loan management, new requests, and real-time communication — putting NHFC in every client's pocket and removing friction that costs us relationships.
                                </p>

                            </div>

                            <div class="strategy-card">

                                <h4>
                                    4. CamDigiKey Adoption 
                                </h4>

                                <p>
                                    Electronic identity verification that accelerates onboarding, closes fraud exposure, and builds a compliance backbone that scales with the portfolio.
                                </p>

                            </div>

                        </div>

                        <p>
                           These moves are not independent. The mobile app feeds a rebuilt LOS. CamDigiKey underpins efficient e-KYC. 
                           The new branch deepens the physical network that digital alone cannot replace. Each move compounds the others.
                        </p>

                        <p>
                            We enter 2026 clear-eyed about asset quality pressures across the sector — and equipped to manage them without flinching from growth. 
                            Discipline and ambition are not opposites. At NHFC, they are the same posture.
                        </p>


                    </section>

                    <!-- CLOSING -->

                    <section class="closing-section">

                        <p>
                            To our Board — your counsel in turbulence was a steady hand.
                        </p>

                        <p>
                            To our regulators and shareholders — your trust is a mandate we carry seriously.
                        </p>

                        <p>
                            To our clients, especially those who chose NHFC when options were scarce — we see you, and we are building for you.
                        </p>

                        <p>
                            And to our staff — the strategies, the systems, the markets we are entering: none of it is credible without the quality of judgment you bring to it every day. Guard that standard. Hold each other to it. It is NHFC's most durable advantage.
                        </p>

                        <div class="signature">

                            <h3>Jung Joo Yong</h3>

                            <span>
                                Chief Executive Officer, NHFC
                            </span>

                        </div>

                    </section>

                </section>

            </div>




            <div class="col-lg-8 col-md-8 col-sm-8 col-12 paragraph-text sm-mb-0 mb-3" *ngIf="isKhmer()">

                <section class="report-wrapper">

                    <!-- INTRO -->
                    <div class="intro-section">

                        <img
                            [src]="baseApiUrl + '/uploads/images/ceo_message/semicolumn.svg'"
                            class="quote-icon">

                        <h2>
                            បំលែងវិបត្តិ និងកត្តាប្រឈមឲ្យក្លាយជាភាពរឹងមាំ និងសមត្ថភាពបន្សាំខ្លួន
                        </h2>

                    </div>

                    <!-- SECTION 1 -->

                    <section class="report-section">

                        <h3>២០២៥ – ឆ្នាំនៃការរក្សាស្ថិរភាព និងការពង្រឹងមូលដ្ឋានសម្រាប់ការរីកចម្រើន</h3>

                        <p>
                            ភាពតានតឹងតាមព្រំដែនតម្រូវការឥណទាននៅមានកម្រិតទាប និងភាពយឺតយ៉ាវនៃការស្តារឡើងវិញក្នុងវិស័យទេសចរណ៍ និងអចលនទ្រព្យបានបន្តដាក់សម្ពាធដល់សកម្មភាពអាជីវកម្មក្នុងឆ្នាំ ២០២៥។ 
                            អត្រាឥណទានមិនដំណើរការ (NPL) ប្រព័ន្ធធនាគារទាំងមូលបានហក់ឡើងដល់ ៨.៩% ពី ៧.៤% ក្នុងឆ្នាំ ២០២៤ ខណៈឥណទានសរុបកើនឡើងត្រឹម ៤.១% ស្មើនឹង ៦៣ ពាន់លានដុល្លារអាមេរិក 
                            នេះបើយោងតាមរបាយការណ៍។ ទន្ទឹមនឹងនេះ ប្រាក់បញ្ញើបានកើនឡើង ១៤.៧% ដល់ ៦៥.៧ ពាន់លានដុល្លារអាមេរិក និងទ្រព្យសកម្មសរុបកើនឡើង ៩.៧% ដល់ ៩៨.៧ ពាន់លានដុល្លារអាមេរិក។ 
                            នេះបង្ហាញថាប្រព័ន្ធធនាគារនៅមានសាច់ប្រាក់គ្រប់គ្រាន់ប៉ុន្តែបន្តប្រតិបត្តិការប្រកបដោយភាពប្រុងប្រយ័ត្នកាន់តែខ្លាំងក្នុងការបញ្ចេញឥណទាន។ 
                            នេះជារបត់ថ្មីមួយនៃការវិវឌ្ឍន៍វិស័យធនាគារពីការរីកចម្រើនផ្អែកលើការពង្រីកផលបត្រឥណទានខ្លាំងឆ្ពោះទៅកាន់ដំណាក់កាលផ្តោតខ្លាំងលើការគ្រប់គ្រងហានិភ័យ និងភាពធន់។
                        </p>

                        <div class="stats-grid">

                            <div class="stat-card">
                                <small>ផលបត្រឥណទាន</small>
                                <h4>63 ពាន់លានដុល្លារ</h4>
                                <span>+4.1% ធៀបឆ្នាំមុន</span>
                            </div>

                            <div class="stat-card">
                                <small>ប្រាក់បញ្ញើសរុប</small>
                                <h4>65.7 ពាន់លានដុល្លារ</h4>
                                <span>+14.7% ធៀបឆ្នាំមុន</span>
                            </div>

                            <div class="stat-card">
                                <small>អនុបាតឥណទានមិនដំណើរការ</small>
                                <h4>8.9%</h4>
                                <span>កើនឡើងពី 7.4% ក្នុងឆ្នាំ2024</span>
                            </div>

                        </div>

                        <p>
                            ក្នុងរយៈពេលកន្លងមកយើងបានផ្លាស់ប្តូរទៅកាន់ការកំណត់តម្លៃឥណទាន និងកម្រិតសិទ្ធិអនុម័តឥណទានទៅកាន់ក្រុមការងារជួរមុខដោយផ្អែកលើគុណភាពឥណទានអមជាមួយការពង្រឹងការត្រួត
                            ពិនិត្យក្រោយបញ្ចេញឥណទានយ៉ាងម៉ត់ចត់ និងការកែប្រែមុខងារផ្ទៃក្នុងពី “អ្នកត្រួតពិនិត្យ” ទៅជា “អ្នកជំរុញ និងសម្របសម្រួលប្រតិបត្តិការ”។ 
                        </p>

                        <p>
                            ក្នុងឆ្នាំ២០២៥នេះផងដែរ NHFC បានដាក់ឲ្យដំណើរការឥណទានពលករ (Migrant Worker Loan) ដែលជាការបង្ហាញយ៉ាងច្បាស់ពីទិសដៅ និងការប្តេជ្ញាចិត្តរបស់យើង។ NHFC 
                            បានជ្រើសរើសផ្តល់ឥណទានដល់ពលករកម្ពុជាដែលទៅធ្វើការនៅក្រៅប្រទេស និងមានកិច្ចសន្យាការងារត្រឹមត្រូវ ដែលជាទីផ្សារកំពុងរីកចម្រើន ប៉ុន្តែមិនទាន់ទទួលបានការបម្រើគ្រប់គ្រាន់ពីប្រព័ន្ធហិរញ្ញវត្ថុ។ 
                            លទ្ធផលក្នុងដំណាក់កាលដំបូងបានបញ្ជាក់ទាំងសក្តានុពលរបស់ទីផ្សារ និងភាពមុតមាំនៃការប្តេជ្ញាចិត្តរបស់យើងចំពោះទីផ្សារនេះ។
                        </p>

                    </section>

                    <!-- PEOPLE SECTION -->

                    <section class="report-section">

                        <h3>ធនធានមនុស្ស – មូលដ្ឋានគ្រឹះនៃការអភិវឌ្ឍ និងនិរន្តរភាពនាពេលអនាគត</h3>

                        <p>
                            រាល់គ្រប់កំណែទម្រង់ទាំងនៅក្នុងប្រព័ន្ធ និងផលិតផលដែលយើងបានបង្កើតឡើងអាចមានប្រសិទ្ធភាព និងទទួលបានផលលុះត្រាតែមានធនធានមនុស្សដែលមានសមត្ថភាពក្នុងការដំណើរការ 
                            និងអភិវឌ្ឍវា។ នៅពេលស្ថាប័នមួយប្រមូលផ្តុំទៅដោយបុគ្គលដែលមានសមត្ថភាពលេចធ្លោមានការប្តេជ្ញាចិត្តខ្ពស់ និងទទួលបានការជឿទុកចិត្តពិតប្រាកដលើការវិនិច្ឆ័យរបស់ពួកគេ 
                            ស្ថាប័ននោះនឹងអាចធ្វើការបានលឿន សម្រេចចិត្តបានត្រឹមត្រូវ និងកាត់បន្ថយនីតិវិធីស្មុគស្មាញដែលមិនចាំបាច់។
                        </p>

                        <div class="quote-box">

                            <p>
                                គុណភាពនៃការសម្រេចចិត្តរបស់ស្ថាប័នមួយមិនអាចលើសពីគុណភាពមនុស្សដែលខ្លួនជ្រើសរើស និងផ្តល់ទំនុកចិត្តបានឡើយ។ ដូច្នេះការបន្តលើកកម្ពស់គុណភាពធនធានមនុស្ស 
                                គឺជាវិធីដ៏មានប្រសិទ្ធភាពបំផុតក្នុងការដោះស្រាយបញ្ហារយៈពេលវែង។
                            </p>

                        </div>

                    </section>

                    <!-- 2026 -->

                    <section class="report-section">

                        <h3>ឆ្នាំ ២០២៦  – ឆ្នាំនៃការបន្តឆ្ពោះទៅមុខ</h3>

                        <p>
                            ការរក្សាបាននូវភាពរឹងមាំ និងការបន្តឈរជើងបាន គឺជាភស្តុតាងបញ្ជាក់ពីការត្រៀមខ្លួនរបស់យើង។ នៅក្នុងឆ្នាំ ២០២៦  NHFC នឹងបន្តឆ្ពោះទៅមុខ 
                            មិនមែនដោយសារបរិយាកាសអាជីវកម្មមានភាពងាយស្រួលឡើងនោះទេប៉ុន្តែដោយសារការត្រៀមខ្លួនមិនរង់ចាំពេលវេលាដែលងាយស្រួលឡើយ។ 
                            ការបោះជំហានសំខាន់ៗចំនួន៤ តភ្ជាប់គ្នាយ៉ាងប្រទាក់ក្រឡានឹងក្លាយជាមូលដ្ឋាននៃការបន្តឆ្ពោះទៅមុខរបស់យើង។
                        </p>

                        <div class="strategy-grid">

                            <div class="strategy-card">

                                <h4>
                                    ទី១. ការបើកសាខាខេត្តកំពង់ឆ្នាំង
                                </h4>

                                <p>
                                    យើងនឹងពង្រីកប្រតិបត្តិការទៅកាន់ខេត្តកំពង់ឆ្នាំងដែលជាទីផ្សារមានសក្តានុពលសម្រាប់ការរីកចម្រើននាពេលអនាគត។ ការមានវត្តមានកាន់តែជិតអតិថិជនមិនត្រឹមតែផ្តល់ភាពងាយស្រួលប៉ុណ្ណោះទេ ប៉ុន្តែថែមទាំងឆ្លុះបញ្ចាំងពីការប្តេជ្ញាចិត្តរយៈពេលវែងរបស់យើងក្នុងការបម្រើ និងគាំទ្រអតិថិជនផងដែរ។
                                </p>

                            </div>

                            <div class="strategy-card">

                                <h4>
                                    ទី២. ទំនើបកម្មប្រព័ន្ធ LOS
                                </h4>

                                <p>
                                    យើងនឹងបន្តធ្វើទំនើបកម្ម និងកសាងរចនាសម្ព័ន្ធប្រព័ន្ធឡើងវិញដើម្បីឱ្យហេដ្ឋារចនាសម្ព័ន្ធស្នូលរបស់យើងអាចវិវឌ្ឍបានលឿនស្របតាមមហិច្ឆតា និងគាំទ្រការរីកចម្រើនរយៈពេលវែងរបស់ស្ថាប័ន។
                                </p>

                            </div>

                            <div class="strategy-card">

                                <h4>
                                    ទី៣. ការអភិវឌ្ឍកម្មវិធីទូរស័ព្ទដៃ (Mobile App)
                                </h4>

                                <p>
                                    ការគ្រប់គ្រងឥណទានការស្នើសុំឥណទានថ្មី និងការទំនាក់ទំនងភ្លាមៗ — នាំយកសេវាកម្មរបស់ NHFC ទៅកាន់ដៃអតិថិជនដោយផ្ទាល់ និងកាត់បន្ថយភាពស្មុគស្មាញដែលអាចប៉ះពាល់ដល់ទំនាក់ទំនងជាមួយអតិថិជន។
                                </p>

                            </div>

                            <div class="strategy-card">

                                <h4>
                                    ទី៤.  ដាក់ឱ្យប្រើប្រាស់ប្រព័ន្ធ e-KYC របស់ CamDigiKey
                                </h4>

                                <p>
                                    ការធ្វើឌីជីថលកម្មលើការផ្ទៀងផ្ទាត់អត្តសញ្ញាណអតិថិជនពន្លឿនដំណើរការនៃការចុះឈ្មោះ ទប់ស្កាត់ការក្លែងបន្លំ និងកសាងមូលដ្ឋានគ្រឹះនៃការអនុលោមតាមបទប្បញ្ញត្តិដែលអាចពង្រីកសមត្ថភាពស្របតាមកំណើននៃផលបត្រឥណទាន។
                                </p>

                            </div>

                        </div>

                        <p>
                           ការអនុវត្តយុទ្ធសាស្ត្រទាំងអស់នេះមិនមែនជាចលនាដាច់ដោយឡែកពីគ្នានោះទេ។ កម្មវិធី Mobile App នឹងផ្តល់ទិន្នន័យទៅកាន់ប្រព័ន្ធ LOS 
                           ដែលត្រូវបានធ្វើទំនើបកម្មខណៈប្រព័ន្ធ CamDigiKey នឹងគាំទ្រដល់ដំណើរការ e-KYC ប្រកបដោយប្រសិទ្ធភាព។ សាខាថ្មី នឹងបន្តពង្រឹងបណ្តាញរូបវន្តដែលប្រព័ន្ធឌីជីថលតែមួយមុខមិនអាចជំនួសបាន។ 
                           រាល់ការបោះជំហាននីមួយៗសុទ្ធតែត្រូវបានរៀបចំឡើងដើម្បីគាំទ្រ និងពង្រឹងគ្នាទៅវិញទៅមក។
                        </p>

                        <p>
                            យើងឈានចូលឆ្នាំ២០២៦ ដោយមិនមើលរំលងសម្ពាធគុណភាពឥណទានដែលកំពុងកើតមាននៅទូទាំងវិស័យឡើយហើយក៏មានភាពរឹងមាំគ្រប់គ្រាន់ក្នុងការគ្រប់គ្រងវាដោយមិនបាត់បង់ទិសដៅនៃការរីកចម្រើន។ 
                            សម្រាប់ NHFC វិន័យ និងមហិច្ឆតាមិនមែនជាអ្វីដែលត្រូវជ្រើសរើសមួយណានោះទេ — វាទាំងពីរ គឺជារបៀបគិតតែមួយ។
                        </p>


                    </section>

                    <!-- CLOSING -->

                    <section class="closing-section">

                        <p>
                            ជូនចំពោះក្រុមប្រឹក្សាភិបាល — ដំបូន្មាន និងការណែនាំ ក្នុងអំឡុងពេលដែលមានភាពមិនច្បាស់លាស់ និងស្មុគស្មាញ គឺជាមូលដ្ឋានគ្រឹះ និងបង្អែកដ៏រឹងមាំសម្រាប់ការដឹកនាំរបស់យើង។
                        </p>

                        <p>
                            ជូនចំពោះនិយតករ និងភាគហ៊ុនិក — ទំនុកចិត្តរបស់លោកអ្នក គឺជាអាណត្តិដែលយើងអនុវត្តដោយការទទួលខុសត្រូវ និងការយកចិត្តទុកដាក់ខ្ពស់បំផុត។
                        </p>

                        <p>
                            ជូនចំពោះអតិថិជនរបស់យើង — ជាពិសេសអតិថិជនដែលបានផ្តល់ទំនុកចិត្តជ្រើសរើស NHFC នៅក្នុងអំឡុងពេលដែលជម្រើសនៅមានកម្រិត យើងសូមថ្លែងអំណរគុណយ៉ាងជ្រាលជ្រៅចំពោះការគាំទ្ររបស់លោកអ្នកហើយប្តេជ្ញាបន្តកសាង និងអភិវឌ្ឍសេវាកម្មឱ្យកាន់តែប្រសើរដើម្បីឆ្លើយតបទៅនឹងទំនុកចិត្តនោះ។
                        </p>

                        <p>
                            ជូនចំពោះបុគ្គលិករបស់យើងទាំងអស់គ្នា — រាល់យុទ្ធសាស្ត្រ ប្រព័ន្ធ និងទីផ្សារដែល NHFC កំពុងពង្រីកវត្តមានចូលទៅនឹងមិនអាចទទួលបានប្រសិទ្ធភាពឡើយប្រសិនបើគ្មានសុភនិច្ឆ័យ វិជ្ជាជីវៈ និងការទទួលខុសត្រូវដែលបុគ្គលិកគ្រប់រូបអនុវត្តជារៀងរាល់ថ្ងៃ។ សូមបន្តរក្សា និងលើកកម្ពស់ស្តង់ដារទាំងនេះតាមរយៈការទទួលខុសត្រូវ ការសហការគ្នា និងការដាស់តឿនគ្នាទៅវិញទៅមកព្រោះនេះគឺជាគុណតម្លៃដ៏សំខាន់ និងប្រកបដោយនិរន្តរភាពបំផុតរបស់ NHFC។
                        </p>

                        <div class="signature">

                            <h3>Jung Joo Yong</h3>

                            <span>
                                (Chief Executive Officer), NHFC
                            </span>

                        </div>

                    </section>

                </section>

            </div>


          

            <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                <app-side-menu></app-side-menu>
            </div>

        </div>
    </div>
    
</main>